import React, { Component } from 'react';
import { withRouter, Route } from "react-router-dom";
import { Container, Input, Button, Row } from 'reactstrap';
import Product from './Product/Product.js';
import ProductDetail from './Product/ProductDetail.js';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames';
import _ from 'lodash';
import jsPDF from 'jspdf/dist/jspdf.debug.js';
import htmlDocx from 'html-docx-js/dist/html-docx.js';
import juice from 'juice';
import fileSaver from 'file-saver';
import spacer from '../assets/spacer.png';
import ReactHtmlParser from 'react-html-parser';

class Page extends Component{
  constructor(props){
    super(props);
    this.state= {
      itemList: [],
      isGrid: true,
      priceFilter: {
        min: 0,
        max: 0
      },
      categorySelection: {},
      uniqueCategories: [],
      categoryParents: [],
      priceMax: 0,
      searchQuery: '',
      featuredProducts: [],
      priceUnit: 'point',
      selectedProductOptions: [],
      sowBuilderProducts: [],
      sowBuilderEstPrice: 0,
      sowBuilderEstHours: 0,
      sowBuilderEstWeeks: 0,
      sowBuilderTerms: '',
      sowBuilderSignature: '',
      sowBuilderPreviewShowing: true,
      sowBuilderPreviewHeight: 400,
      sowBuilderDownloadDocType: 'word',
    }
    this.handleSearchQueryChange = this.handleSearchQueryChange.bind(this);
    this.handleSearchClear = this.handleSearchClear.bind(this);
    this.handleCategorySelect = this.handleCategorySelect.bind(this);
    this.setPriceFilter = this.setPriceFilter.bind(this);
    this.setGridView = this.setGridView.bind(this);
    this.setListView = this.setListView.bind(this);
    this.backToPage = this.backToPage.bind(this);
    this.formatPriceFilterLabel = this.formatPriceFilterLabel.bind(this);
    this.renderProductPriceTime = this.renderProductPriceTime.bind(this);
    this.handleSowBuilderAdd = this.handleSowBuilderAdd.bind(this);
    this.isSowBuilderAdded = this.isSowBuilderAdded.bind(this);
    this.handleSowBuilderRemove = this.handleSowBuilderRemove.bind(this);
    this.setSowBuilderTermsSignature = this.setSowBuilderTermsSignature.bind(this);
    this.isSowBuilderTermsSignatureOption = this.isSowBuilderTermsSignatureOption.bind(this);
    this.toggleSowBuilderPreview = this.toggleSowBuilderPreview.bind(this);
    this.getSowBuilderSummary = this.getSowBuilderSummary.bind(this);
    this.setSowBuilderSummaryRef = this.setSowBuilderSummaryRef.bind(this);
    this.isSowBuilderPreviewShowing = this.isSowBuilderPreviewShowing.bind(this);
    this.setSowBuilderPreviewHeight = this.setSowBuilderPreviewHeight.bind(this);
    this.handleSowBuilderDownload = this.handleSowBuilderDownload.bind(this);
    this.isSowBuilderEmpty = this.isSowBuilderEmpty.bind(this);

    this.props.history.listen((location) => {
      if(location.pathname.indexOf('/item') !== 0 && this.props.detailItem) {
        this.props.setPageDetail();
      }
    });
  }

  componentDidMount(){
    const items = this.props.data.contents.items;

    if(items){
      //populate category arrays
      const uniqueCategories = [];
      items.forEach((item) => {
        item.categories.forEach((cat) => {
          const currNames = uniqueCategories.map((cat) => cat.name);
          if(!_.includes(currNames, cat.name)){
            uniqueCategories.push(cat);
          }
        });
      });
      this.setState({uniqueCategories: uniqueCategories});
      const categoryParents = [];
      uniqueCategories.forEach((cat) => {
        const selected = this.state.categorySelection;
        selected[cat.name] = false;
        this.setState({selected});
        if(cat.parent_name && !_.includes(categoryParents, cat.parent_name) && cat.parent_name !== 'Segments'){
          categoryParents.push(cat.parent_name);
        }
      });
      this.setState({categoryParents: categoryParents});

      this.setState({itemList: items});

      //calculate priors for price filter
      const maxPrice = Math.max.apply(Math, items.map(card => card.points));
      this.setState({priceMax: maxPrice});
      this.setState({priceFilter: {min: 0, max: maxPrice}});

      //filter out featuredProducts that wont be otherwise filterable
      this.setState({featuredProducts: items.filter( product => product.is_featured === true)});
    }
  }


  handleSearchQueryChange(event){
    const val = event.target.value.toLowerCase();
    this.setState({searchQuery: val});
  }
  handleSearchClear(){
    this.setState({searchQuery: ''});
  }

  setPriceFilter(value) {
    value.min = Math.max(value.min, 0);
    value.max = Math.min(value.max, this.state.priceMax);
    this.setState({ priceFilter: value });
  }
  isPriceFiltered() {
    return this.state.priceFilter.min > 0 || this.state.priceFilter.max < this.state.priceMax;
  }
  formatPriceFilterLabel(value) {
    const normalizedValue = value >= 1000 ? value/1000 + "k" : value;
    return `${normalizedValue} ${this.state.priceUnit}${value !== 1 ? "s" : ""}`;
  }


  setGridView(){
    this.setState({isGrid: true});
  }

  setListView(){
    this.setState({isGrid: false});
  }

  renderProductPriceTime(item, opts) {
    opts = opts || {};
    if(!item.points){
      return null;
    }
    const points = `${item.points.toLocaleString()} ${this.state.priceUnit}${item.points !== 1 ? "s" : ""}`;
    const duration = item.duration ? `${item.duration.toLocaleString()} hour${item.duration !== 1 ? "s" : ""}` : null;
    if(points || duration) {
      return <div className="priceTime">
              {[points ? <span key={`p${item.id}`}>{points}</span> : null, opts.download ? <span key={`p2${item.id}`}> | </span> : null, duration ? <span key={`d${item.id}`}>{duration}</span> : null]}
            </div>;
    }
  }


  backToPage() {
    this.props.log_transaction('viewed', 'page','home');
    this.props.setPageDetail();
  }

  getItems(){
    let itemList = this.props.data.contents.items;

    if(!itemList){
      return null;
    }

    //handle category filtering
    if(_.includes(this.state.categorySelection, true)){
      const selectedServiceTypeCategories = this.state.uniqueCategories.filter(cat => cat.parent_name === 'Service Type' && this.state.categorySelection[cat.name]);
      const selectedProductCategories = this.state.uniqueCategories.filter(cat => cat.parent_name === 'Product' && this.state.categorySelection[cat.name]);
      if(selectedServiceTypeCategories.length) {
        itemList = itemList.filter(card => (card.categories.map(cat => cat.name).some(cat => selectedServiceTypeCategories.some(c => c.name === cat))));
      }
      if(selectedProductCategories.length) {
        itemList = itemList.filter(card => (card.categories.map(cat => cat.name).some(cat => selectedProductCategories.some(c => c.name === cat))));
      }
      if(itemList.length === 0){
        return <h3 className="error">Your selected categories have no associated items.</h3>
      }
    }

    itemList = itemList.filter(card => (card.name.toLowerCase().indexOf(this.state.searchQuery) !== -1 || card.description.toLowerCase().indexOf(this.state.searchQuery) !== -1) && (card.points >= this.state.priceFilter.min && card.points <= this.state.priceFilter.max));

    if(itemList.length === 0){
      if(this.state.searchQuery !== ''){
        return <h3 className="error">Your search query did not produce any results. Please try again.</h3>
      }else{
        return <h3 className="error">Your price filter did not produce any results. Please try again.</h3>
      }
    }
    const display = this.state.isGrid;
    return(
        <Row className="items">
          {itemList.map((item, index) => {
            return(
              <Product
                  log_transaction={this.props.log_transaction}
                  data={item}
                  index={index}
                  key={index}
                  isGrid={display}
                  renderProductPriceTime={this.renderProductPriceTime}
                  setPageDetail={this.props.setPageDetail}
                  isSowBuilderAdded={this.isSowBuilderAdded}
                  categoryClassNameMapping={this.categoryClassNameMapping}
              />
            );
          })}
        </Row>
    );
  }

  handleCategorySelect(event){
    const name = event.target.getAttribute('name') || event.target.parentNode.getAttribute('name');
    if(!name){
      return;
    }

    const selected = this.state.categorySelection;
    selected[name] = !selected[name];
    this.setState({selected});
  }




  handleSowBuilderAdd(product) {
    const { sowBuilderProducts, selectedProductOptions } = this.state;
    let selected = _.find(selectedProductOptions, {productId: product.id});
    if(selected) {
      product.options = selected.options;
    }
    this.props.log_transaction('added to SOW', 'item', product.id, product.name);
    sowBuilderProducts.push(product);
    this.setSowBuilderTermsSignature(sowBuilderProducts);

    this.setState({ sowBuilderProducts: sowBuilderProducts }, () => { this.calcSowBuilderSummary(); });

    if(!this.isSowBuilderPreviewShowing()) {
      this.toggleSowBuilderPreview();
    }
  }

  handleSowBuilderRemove(product, e) {
    if(e)
      e.preventDefault();

    this.props.log_transaction('removed from SOW', 'item', product.id, product.name);
    const { sowBuilderProducts } = this.state;
    sowBuilderProducts.splice(sowBuilderProducts.indexOf(product), 1);
    this.setSowBuilderTermsSignature(sowBuilderProducts);
    this.setState({ sowBuilderProducts: sowBuilderProducts }, () => { this.calcSowBuilderSummary(); });
    if(!this.state.sowBuilderProducts.length && this.isSowBuilderPreviewShowing()) {
      this.toggleSowBuilderPreview();
    }
  }

  setSowBuilderTermsSignature(sowBuilderProducts) {
    let options = [].concat.apply([], sowBuilderProducts.map(function(p) { return p.options||[]; }));
    let terms = _.find(options, {terms: true});
    if(terms) {
      terms = terms.description;
    }
    let signature = _.find(options, {signature: true});
    if(signature) {
      signature = signature.description;
    }

    this.setState({
      sowBuilderTerms: terms,
      sowBuilderSignature: signature
    });
  }

  isSowBuilderAdded(product) {
    const { sowBuilderProducts } = this.state;
    return sowBuilderProducts.indexOf(product) !== -1;
  }

  isSowBuilderPreviewShowing() {
    return this.state.sowBuilderPreviewShowing;
  }

  isSowBuilderEmpty() {
    return !this.state.sowBuilderProducts.length;
  }

  toggleSowBuilderPreview() {
    let { sowBuilderPreviewShowing } = this.state;
    sowBuilderPreviewShowing = !sowBuilderPreviewShowing;
    this.setState({sowBuilderPreviewShowing: sowBuilderPreviewShowing});

    /*if(!this.props.detailItem)
      this.props.isDimmed(sowBuilderPreviewShowing);*/
  }

  setSowBuilderPreviewHeight() {
    const sowBuilderSummaryElem = document.getElementsByClassName("sowBuilderSummary")[0];
    if(sowBuilderSummaryElem) {
      const sowBuilderSummaryRect = sowBuilderSummaryElem.getBoundingClientRect();
      this.setState({sowBuilderPreviewHeight: window.innerHeight - sowBuilderSummaryRect.top - 150});
    }
  }

  buildSowBuilderDownloadVariable(name, opts) {
    return `&lt;${opts && opts.closingTag ? '/' : ''}${name}&gt;`;
  }

  buildSowBuilderDownloadVariableTagRegex(name) {
    return new RegExp(this.buildSowBuilderDownloadVariable(name) + '(.*?)' + this.buildSowBuilderDownloadVariable(name, {closingTag: true}), 'g');
  }

  handleSowBuilderDownloadSigField(field) {
    const fieldLeft = (field === 'Customer' ? this.state.sowBuilderClient : field);
    return '<pre>' + fieldLeft + '&#9;'.repeat(5 - Math.floor(Math.max(0,(fieldLeft.length-2)) / 10)) + (field === 'Customer' ? 'erwin, Inc.' : field) + '</pre><br><br><pre style="font-family:Arial !important;">_________________________________&#9;_________________________________</pre><br>';
  }

  handleSowBuilderDownloadPageBreak(html) {
    return html.replace(new RegExp(this.buildSowBuilderDownloadVariable('Page Break'), 'g'), '<br class="pagebreak" clear="all" style="page-break-before:always" />');
  }

  cleanSowBuilderDownload(docType) {
    var stylesheet = '';
    for (var i in document.styleSheets) {
      if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf("SowBuilderDownload") !== -1) {
        stylesheet = document.styleSheets[i];
        break;
      }
    }
    var styles = '';
    for (var s = 0; s < stylesheet.cssRules.length; ++s) {
      styles += stylesheet.cssRules[s].cssText;
    }

    var cleanElem = document.createElement('div');
    cleanElem.innerHTML = '<style>' + styles + '</style>' + document.getElementById('sowBuilderDownload').outerHTML;

    var termsElem = cleanElem.querySelector(".terms .content");
    if(termsElem) {
      termsElem.innerHTML = termsElem.innerHTML
          .replace(this.buildSowBuilderDownloadVariable('Pricing'), '$' + this.state.sowBuilderEstPrice.toLocaleString())
          .replace(this.buildSowBuilderDownloadVariable('Estimated Weeks'), '<span class="estweeks">' + this.state.sowBuilderProducts.length * 4 + ' weeks</span>')
          .replace(this.buildSowBuilderDownloadVariable('Total Hours'), this.state.sowBuilderEstHours)
          .replace(this.buildSowBuilderDownloadVariable('Date'), this.state.sowBuilderDate)
          .replace(this.buildSowBuilderDownloadVariableTagRegex('Sig Field'), (match, field) => this.handleSowBuilderDownloadSigField(field))
          .replace(new RegExp(this.buildSowBuilderDownloadVariable('Customer'), 'g'), this.state.sowBuilderClient);

      if(docType !== 'word') {
        termsElem.innerHTML = this.handleSowBuilderDownloadPageBreak(termsElem.innerHTML);
      }

      var headerEndsVariable = this.buildSowBuilderDownloadVariable('Header Ends');
      var termsHeaderElem = document.createElement('div');
      termsHeaderElem.classList.add("termsHeader");
      termsHeaderElem.innerHTML = termsElem.innerHTML.substring(0, termsElem.innerHTML.indexOf(headerEndsVariable)) +
          '<div><hr /><div class="sep">_____________________________________________________________________________________________________________</div></div>';
      termsElem.innerHTML = termsElem.innerHTML.substring(termsElem.innerHTML.indexOf(headerEndsVariable)).replace(headerEndsVariable, '');

      var logoElem = cleanElem.querySelector("#sowBuilderDownload > img");
      logoElem.parentNode.insertBefore(termsHeaderElem, logoElem.nextSibling);
    }

    var signatureElem = cleanElem.querySelector(".signature .content");
    if(signatureElem) {
      signatureElem.innerHTML = signatureElem.innerHTML
          .replace(this.buildSowBuilderDownloadVariableTagRegex('Sig Field'), (match, field) => this.handleSowBuilderDownloadSigField(field))
          .replace(new RegExp(this.buildSowBuilderDownloadVariable('Customer'), 'g'), this.state.sowBuilderClient);
    }

    [].forEach.call(cleanElem.querySelectorAll("ol"), function (n) {
      if(n.firstChild.tagName === 'LI' && n.firstChild.getAttribute('data-list') === 'bullet') {
        n.outerHTML = '<ul>' + n.innerHTML + '</ul>';
      }
    });

    if(docType === 'word') {
      [].forEach.call(cleanElem.querySelectorAll(".ql-align-center"), function (n) {
        n.innerHTML = '<center>' + n.innerHTML + '</center>';
      });
      [].forEach.call(cleanElem.querySelectorAll("hr"), function (n) {
        n.parentNode.removeChild(n);
      });
    }
    else {
      [].forEach.call(cleanElem.querySelectorAll("p, li"), function (n) {
        if(n.innerHTML === '&nbsp;') {
          n.parentNode.removeChild(n);
        }

        if (n.classList.contains('ql-indent-1') || n.classList.contains('ql-indent-2')) {
          if(n.innerHTML === '<br>') {
            n.innerHTML = '';
          }
          else {
            var indent = document.createElement("div");
            indent.classList.add("indent");

            if(n.tagName === 'P' && n.firstChild.nodeType === Node.TEXT_NODE) {
              n.innerHTML = '<span>' + n.innerHTML + '</span>';
            }
            if (n.classList.contains('ql-indent-1')) {
              indent.innerHTML = '<ul><li>' + n.innerHTML + '</li></ul>';
            }
            else if (n.classList.contains('ql-indent-2')) {
              indent.innerHTML = '<ul><li><ul><li>' + n.innerHTML + '</li></ul></li></ul>';
            }
            n.innerHTML = indent.outerHTML;
          }
        }
        else {
          if(n.innerHTML === '<br>') {
            n.innerHTML = '';
            var indentSpacer = document.createElement("img");
            indentSpacer.setAttribute('src', spacer);
            n.appendChild(indentSpacer);
            n.className = 'emptyRow';
          }
        }
      });
    }

    return cleanElem;
  }


  handleSowBuilderDownload(docType, e) {
    if(docType && e) {
      e.stopPropagation();
    }
    this.props.log_transaction('downloaded SOW', docType, this.state.sowBuilderProducts.map((prod) => prod.id), this.state.sowBuilderProducts.map((prod) => prod.name));
    docType = docType||this.state.sowBuilderDownloadDocType;
    this.setState({sowBuilderDownloadDocType: docType}, function() {

      var downloadElem = document.getElementById('sowBuilderDownload');
      downloadElem.classList.add("active");

      if(docType === 'word') {
        downloadElem.classList.add("doc");

        var cleanElem = this.cleanSowBuilderDownload(docType);

        [].forEach.call(cleanElem.querySelectorAll("p"), function (p) {
          if(p.innerText.trim() === '' || (p.children.length === 1 && p.children[0].tagName === 'BR')) {
            p.parentNode.removeChild(p);
          }
        });

        var images = cleanElem.querySelectorAll("img");
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        [].forEach.call(images, function (imgElement) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          canvas.width = imgElement.width;
          canvas.height = imgElement.height;
          ctx.drawImage(imgElement, 0, 0);
          var dataURL = canvas.toDataURL();
          imgElement.setAttribute('src', dataURL);
        });
        canvas.remove();

        var docHtml =
            '<!DOCTYPE html>' +
            '<html>' +
            '<body>' +
            this.handleSowBuilderDownloadPageBreak(juice(cleanElem.outerHTML)) +
            '</body>' +
            '</html>';

        var converted = htmlDocx.asBlob(docHtml, {orientation: 'landscape', margins: {top: 720}});
        fileSaver.saveAs(converted, 'PTC-Services.docx');
        downloadElem.classList.remove("active");
        downloadElem.classList.remove("doc");
      }

      else {
        downloadElem.classList.add("pdf");

        var pdf = new jsPDF('p', 'pt', 'letter');
        /*pdf.setLineWidth(1); pdf.setDrawColor(225, 225, 225); pdf.rect(10, 83, 200, 55);*/
        var margins = {top: 20, bottom: 20, left: 20, right: 20};
        pdf.fromHTML(
            this.cleanSowBuilderDownload(docType),
            margins.left,
            margins.top,
            {
              width: 550
            },
            function (dispose) {
              pdf.save('PTC-Services.pdf');
              downloadElem.classList.remove("active");
              downloadElem.classList.remove("pdf");
            }, margins);
      }
    });
  }


  toAscii(str) {
    str = str.replace(/&(l|g)t;/g, '{$1t}');
    var tmp = document.createElement('textarea');
    tmp.innerHTML = str;
    str = tmp.value.replace(/[\u0100-\uffff]/g, ch => {
      switch (ch) {
        case "“":
        case "”�":
          return '"';
        case "’":
        case "‘":
          return "'";
        default:
          return "";
      }
    });
    str = str.replace(/{(l|g)t}/g, '&$1t;');
    return str;
  }




  isSowBuilderTermsSignatureOption(option) {
    return option.terms || option.signature;
  }



  calcSowBuilderSummary() {
    let estPrice = 0, estHours = 0, estWeeks = 0;
    const { sowBuilderProducts } = this.state;
    sowBuilderProducts.concat([].concat.apply([], sowBuilderProducts.map(function(p) { return p.options||[]; }))).forEach((p) => {
      if(this.isSowBuilderTermsSignatureOption(p)) {
        return;
      }
      let duration = p.duration || 0;
      if(p.points) {
        estPrice += p.points;
      }
      else if(p.serviceRateLabel && p.serviceRateLabel !== '') {
        const m = p.serviceRateLabel.match(/[\d,]+/);
        if(m.length) {
          const n = parseInt(m[0].replace(',',''),10);
          if(!isNaN(n)) {
            if(p.serviceRateLabel.toLowerCase().indexOf('day') !== -1) {
              duration = n*8;
            }
            else if(p.serviceRateLabel.toLowerCase().indexOf('week') !== -1) {
              duration = n*40;
            }
            else {
              estPrice += n;
            }
          }
        }
      }
      estHours += duration;
    });
    estWeeks = Math.round((estHours / 40)*2)/2;

    this.setState({sowBuilderEstPrice: estPrice, sowBuilderEstHours: estHours, sowBuilderEstWeeks: estWeeks});
  }





  getSowBuilderSummary(product) {
    const { sowBuilderEstPrice, sowBuilderEstHours, sowBuilderEstWeeks } = this.state;
    return (
        <div ref={this.setSowBuilderSummaryRef} className={`sowBuilderSummary ${this.isSowBuilderPreviewShowing() ? 'preview-showing' : ''} ${this.state.sowBuilderProducts.length ? 'has-products' : ''}`}>
          <div className="summary">
            <div>Total Estimated Points:{sowBuilderEstPrice ? <span>{sowBuilderEstPrice.toLocaleString()}</span> : <span>&mdash;</span>}</div>
            <div>Total Estimated Hours:{sowBuilderEstHours ? <span>{sowBuilderEstHours.toLocaleString()}</span> : <span>&mdash;</span>}</div>
            <div>Total Estimated Weeks:{sowBuilderEstWeeks ? <span>{sowBuilderEstWeeks.toLocaleString()}</span> : <span>&mdash;</span>}</div>
          </div>
          <div className="cta">
            <button className="download" onClick={() => this.handleSowBuilderDownload(product)}><div className="label">Download</div><div className="docTypes"><i className={`word ${this.state.sowBuilderDownloadDocType === 'word' ? 'active' : ''}`} onClick={(e) => this.handleSowBuilderDownload('word', e)}></i><i className={`pdf ${this.state.sowBuilderDownloadDocType === 'pdf' ? 'active' : ''}`} onClick={(e) => this.handleSowBuilderDownload('pdf', e)}></i></div></button>
            <button className="preview" onClick={() => this.toggleSowBuilderPreview()}><div className="label">Summary</div></button>
          </div>
          <div className="download" id="sowBuilderDownload">
            <img className="logo" align="center" src="data:image/png;base64,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" alt="" />
            <div className="summary">
              <div>Total Estimated Points:&nbsp;&nbsp;{sowBuilderEstPrice ? <span>{sowBuilderEstPrice.toLocaleString()}</span> : <span>-</span>}</div>
              <div>Total Estimated Hours:&nbsp;&nbsp;{sowBuilderEstHours ? <span>{sowBuilderEstHours.toLocaleString()}</span> : <span>-</span>}</div>
              <div>Total Estimated Weeks:&nbsp;&nbsp;{sowBuilderEstWeeks ? <span>{sowBuilderEstWeeks.toLocaleString()}</span> : <span>-</span>}</div>
              <div className="sep">-</div>
            </div>
            {_.map(this.state.sowBuilderProducts, (product, p) => {
              return (
                  <div className="item" key={p}>
                    { p > 0 &&
                    <div><hr /><div className="sep">_____________________________________________________________________________________________________________</div></div>
                    }
                    <h5>{product.name}</h5>
                    {this.renderProductPriceTime(product, {download: true})}
                    <p dangerouslySetInnerHTML={{__html: this.toAscii(product.description)}}></p>
                    {product.rows && _.map(product.rows, (row, r) => {
                      let value = row.control;
                      if (row.control && row.control[0] === '"') {
                        value = value.substring(1, row.control.length - 1);
                      }
                      if('editor' === row.row_type && value && row.options.addToProposal) {
                        return (
                            <div className="productRow" key={`${p}_${r}`}>
                              {row.label !== "SOW Content" &&
                              <em>
                                <h2>
                                  {row.label}
                                </h2>
                              </em>}

                              <div>
                                { ReactHtmlParser(this.toAscii(value).replace(/^"(.+)"$/,'$1').replace(/style="[^"]*"/g, "").replace(/\\"/g, "\"").replace(/\\n/g, '')) }
                              </div>
                              <div>
                                <hr />
                                <div className="sep">
                                  _____________________________________________________________________________________________________________
                                </div>
                              </div>
                              {_.map(
                                  _.filter(row.options.items, { isChecked: true }),
                                  (option, o) => {
                                    return (
                                        <div className="option" key={`${p}_${r}_${o}`}>
                                          <div
                                              className={`sep ${o === 0 ? "first" : ""}`}
                                          >
                                            -
                                          </div>
                                          <h5>{option.label}</h5>
                                          {this.renderProductPriceTime(option, {option: true, download: true})}
                                          <p dangerouslySetInnerHTML={{__html: this.toAscii(option.description)}} />
                                        </div>
                                    );
                                  }
                              )}
                            </div>
                        );
                      }
                      else {
                        return null;
                      }
                    })}
                  </div>
              );
            })}

            { this.state.sowBuilderTerms &&
            <div className="terms">
              <hr /><div className="sep">_____________________________________________________________________________________________________________</div>
              <div className="content">
                <p dangerouslySetInnerHTML={{__html: this.toAscii(this.state.sowBuilderTerms)}}></p>
              </div>
            </div>
            }

            { this.state.sowBuilderSignature &&
            <div className="signature">
              <hr /><div className="sep">_____________________________________________________________________________________________________________</div>
              <div className="content">
                <p dangerouslySetInnerHTML={{__html: this.toAscii(this.state.sowBuilderSignature)}}></p>
              </div>
            </div>
            }

          </div>
          <div className="preview" style={{maxHeight: this.state.sowBuilderPreviewHeight}}>
            {_.map(this.state.sowBuilderProducts, (product, p) => {
              return (
                  <div key={p}>
                    <h5><div className="remove" onClick={() => this.handleSowBuilderRemove(product)}></div>{product.name}</h5>
                    {this.renderProductPriceTime(product)}
                    <p dangerouslySetInnerHTML={{__html: product.description}}></p>

                  </div>
              );
            })}
          </div>
        </div>
    )
  }

  /*
                    {product.rows && _.map(product.rows, (row, r) => {
                      return (
                          <div className="productRow" key={`${p}_${r}`}>
                            <label>{row.label}</label>
                            {_.map(row.options.items, (option, o) => {
                              if(!option.isChecked) {
                                return null;
                              }
                              return (
                                  <div className="option" key={`${p}_${r}_${o}`}>
                                    <h5>{option.label}</h5>
                                    {this.renderProductPriceTime(option)}
                                    <p dangerouslySetInnerHTML={{__html: option.description}}></p>
                                  </div>
                              );
                            })}
                          </div>
                      );
                    })}
                    this was asked to be removed
  */

  setSowBuilderSummaryRef(node) {
    this.sowBuilderSummaryRef = node;
  }


  categoryClassNameMapping = [
    {category: 'vrd', className: 'vrd'},
    {category: 'success path', className: 'successpath'},
    {category: 'success plan', className: 'successplan'},
    {category: 'success services', className: 'successservice'},
    {category: 'support plan', className: 'supportplan'},
    {category: 'time-based services', className: 'timebased'},
    {category: 'rapid outcome', className: 'rapidoutcome'},
  ]

  render(){
    const data = this.props.data;
    data.contents.items.forEach(card => {
      card.points = 0;
      card.duration = 0;
      if(card.rows) {
        const points = card.rows.find(row => row.label.replace("[CUSTOMER FACING]","").trim() === "Success Points");
        if(points && points.control && !isNaN(points.control)) {
          card.points = parseInt(points.control);
        }
        const duration = card.rows.find(row => row.label.replace("[CUSTOMER FACING]","").trim() === "Duration");
        if(duration && duration && !isNaN(duration.control)) {
          card.duration = parseInt(duration.control);
        }
      }
    });
    return (
        <div>
          <Route
              exact
              path="/"
              render={() => {
                return(
                    <div className="page">
                      <div className="hero">
                        <div>
                          <div className="titles">
                            <Container>
                              <Row>
                                <h1 className="title">{data.name}</h1>
                                <h2 className="subtitle">{data.description}</h2>
                              </Row>
                            </Container>
                          </div>
                          <Container>
                            {this.state.featuredProducts.length > 0 &&
                            <Row className="featured justify-content-center">
                              {this.state.featuredProducts.map((item, index) => {
                                return(
                                    <Product
                                        className="product-featured"
                                        data={item}
                                        index={index}
                                        key={index}
                                        log_transaction = {this.props.log_transaction}
                                        isGrid={true}
                                        setPageDetail={this.props.setPageDetail}
                                        renderProductPriceTime={this.renderProductPriceTime}
                                        isSowBuilderAdded={this.isSowBuilderAdded}
                                        categoryClassNameMapping={this.categoryClassNameMapping}
                                    />
                                );
                              })}
                            </Row>}
                          </Container>

                          <div className="categories">
                            <Container>
                              <Row>
                                {this.state.categoryParents.sort(function(a, b){
                                   var nameA=a.toLowerCase(), nameB=b.toLowerCase();
                                   if (nameA < nameB) //sort string ascending
                                    return 1;
                                   if (nameA > nameB)
                                    return -1;
                                   return 0; //default return value (no sorting)
                                  }).map((parentName) => {
                                  return (<div key={parentName} className={"col col-lg-" + Math.floor(12 / this.state.categoryParents.length) }>
                                    <div>
                                      <div className="parent">{parentName}</div>
                                      <div className="list">
                                        <ul>
                                          {this.state.uniqueCategories.filter((cat)=> cat.parent_name === parentName).map((cat)=>{
                                            let categoryClassName = this.categoryClassNameMapping.find(m => _.includes(cat.name.toLowerCase(), m.category));
                                            if(categoryClassName)
                                              categoryClassName = categoryClassName.className;

                                            return(
                                              <li key={cat.name}><Button outline onClick={this.handleCategorySelect} name={cat.name} color="secondary" className={classNames(categoryClassName, { active: this.state.categorySelection[cat.name] })} size="sm"><FontAwesomeIcon icon={this.state.categorySelection[cat.name] ? "check-square" : "square"} name={cat.name} />{cat.name}</Button></li>
                                            )
                                          })}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>);
                                })}
                              </Row>
                            </Container>
                          </div>
                        </div>
                      </div>
                      <Container>
                        {this.props.data.contents.items &&
                        <Row className={`options ${this.isSowBuilderEmpty() ? "sowBuilderEmpty" : ""}`}>
                          {(this.props.data.contents.items) &&
                          <div className="search">
                            <Input placeholder="Search" value={this.state.searchQuery} onChange={this.handleSearchQueryChange} />
                            {this.state.searchQuery && <FontAwesomeIcon icon="times" onClick={this.handleSearchClear} />}
                          </div>
                          }
                          <div className="listGridToggle">
                            <Button className={classNames({ active: this.state.isGrid })} onClick={this.setGridView}><FontAwesomeIcon icon="th" /></Button>
                            <Button className={classNames({ active: !this.state.isGrid })} onClick={this.setListView}><FontAwesomeIcon icon="list-ul" /></Button>
                          </div>
                          {this.state.priceMax > 0 && <div className={"price" + (this.isPriceFiltered() ? " filtered" : "")}>
                            <InputRange
                                maxValue={this.state.priceMax}
                                minValue={0}
                                step={1}
                                formatLabel={this.formatPriceFilterLabel}
                                value={this.state.priceFilter}
                                onChange={this.setPriceFilter} />
                          </div>}
                          {this.getSowBuilderSummary()}
                        </Row>}
                        {this.getItems()}
                      </Container>
                    </div>
                );
              }}
          />
          <Route
              path="/item/:id"
              render={({match}) => {
                const detailItem = _.find(this.props.data.contents.items, {id: match.params.id});
                return (
                    <ProductDetail
                        user = {this.props.user}
                        isLoggedIn = {this.props.isLoggedIn}
                        productRowsFetch = {this.props.productRowsFetch}
                        productRowsLazyFetch={this.props.productRowsLazyFetch}
                        log_transaction={this.props.log_transaction}
                        data={detailItem}
                        setPageDetail={this.props.setPageDetail}
                        backToPage={this.backToPage}
                        renderProductPriceTime={this.renderProductPriceTime}
                        getSowBuilderSummary={this.getSowBuilderSummary}
                        setSowBuilderPreviewHeight={this.setSowBuilderPreviewHeight}
                        isSowBuilderPreviewShowing={this.isSowBuilderPreviewShowing}
                        toggleSowBuilderPreview={this.toggleSowBuilderPreview}
                        isSowBuilderAdded={this.isSowBuilderAdded}
                        handleSowBuilderAdd={this.handleSowBuilderAdd}
                        handleSowBuilderRemove={this.handleSowBuilderRemove}
                    />
                );
              }
              } />
        </div>
    );
  }
}

export default withRouter(Page);
